import React from "react";
import IconButton from "UI/IconButton";
import classNames from "classnames";

const classes = {
    icon: (focused, disabled) => classNames(
        'w-6 text-gray-300 rounded',
        {
            'text-gray-600 hover:bg-gray-100': ! disabled && focused
        }
    )
};

const TrayButton = ({icon: Icon, focused, onClick, disabled, ...props}) => (
    <IconButton
        {...props}
        disabled={disabled}
        tabIndex='-1'
        type='blank'
        onClick={e => {
            e.preventDefault();
            onClick();
        }
    }>
        <Icon className={classes.icon(focused, disabled)} />
    </IconButton>
);

export default TrayButton;
